import { render } from "./ImprestCashierPage.vue?vue&type=template&id=28ec08e0"
import script from "./ImprestCashierPage.vue?vue&type=script&lang=js"
export * from "./ImprestCashierPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__